export const getters = {
    loadingNavigation: state => state.loadingNavigation,
    errorNavigation: state => state.errorNavigation,
    navigation: state => state.navigation
}